import { Suspense, type ReactNode } from "react";

import { SimpleLoading } from "@/components/widgets/SimpleLoading";

/** Suspense boundary for React.lazy route chunks. */
function RouteSuspense({ children }: { children: ReactNode }) {
  return <Suspense fallback={<SimpleLoading />}>{children}</Suspense>;
}

export { RouteSuspense };
